<template>
  <header class="site-header">
    <div class="header-top">
      <router-link to="/" class="site-logo">birdea</router-link>
      <a href="tel:720992745" class="header-phone-center">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.17.68.37 1.34.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 5.93 5.93l.95-.95a2 2 0 0 1 2.11-.45c1.47.33 2.13.53 2.81.7A2 2 0 0 1 21.5 16v.92z"/></svg>
        720 992 745
      </a>
      <div class="header-controls">
        <div class="lang-currency">
          <select class="header-select" v-model="currentCurrency" @change="changeCurrency">
            <option value="PLN">PLN</option><option value="EUR">EUR</option>
            <option value="USD">USD</option><option value="CZK">CZK</option>
            <option value="HUF">HUF</option><option value="BGN">BGN</option>
            <option value="RON">RON</option><option value="DKK">DKK</option>
            <option value="SEK">SEK</option>
          </select>
          <select class="header-select" v-model="currentLang" @change="changeLanguage">
            <option value="pl">PL</option><option value="en">EN</option>
            <option value="de">DE</option><option value="cs">CZ</option>
            <option value="ro">RO</option><option value="lt">LT</option>
            <option value="hr">HR</option><option value="bg">BG</option>
            <option value="hu">HU</option><option value="it">IT</option>
            <option value="et">EE</option><option value="da">DK</option>
            <option value="sk">SK</option><option value="sl">SL</option>
            <option value="sv">SE</option><option value="fr">FR</option>
            <option value="es">ES</option><option value="nl">NL</option>
          </select>
        </div>
        <router-link to="/cart" class="cart-btn" aria-label="Koszyk">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" width="22" height="22">
            <circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>
            <path d="M1.5 3.5h3l2.7 10.5a2 2 0 0 0 2 1.5h7.8a2 2 0 0 0 2-1.6l1.7-7.7H5.5"/>
          </svg>
          <span v-if="cartCount" class="cart-count">{{ cartCount }}</span>
        </router-link>
      </div>
    </div>

    <!-- PASEK Z TELEFONEM I KATEGORIAMI -->
    <div class="header-nav-bar">
      <!-- Kategorie desktop: poziomo -->
      <span class="nav-label">{{ translations.nav?.categories_label || "Kategorie:" }}</span>
      <nav class="header-nav">
        <router-link to="/category" class="nav-item nav-all">{{ translations.nav?.all || "Wszystkie" }}</router-link>
        <div
          v-for="c in categories"
          :key="c.id"
          class="nav-item nav-cat"
          @mouseenter="c._open = true"
          @mouseleave="c._open = false"
        >
          <router-link :to="`/category/${c.slug}`" class="nav-cat-link">{{ c.name }}</router-link>
        </div>
      </nav>

    </div>

    <!-- MOBILE: telefon wyśrodkowany -->
    <div class="mobile-phone-bar">
      <a href="tel:720992745">
        <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07A19.5 19.5 0 0 1 4.69 12 19.79 19.79 0 0 1 1.61 3.4 2 2 0 0 1 3.6 1.21h3a2 2 0 0 1 2 1.72c.17.68.37 1.34.7 2.81a2 2 0 0 1-.45 2.11L7.91 8.8a16 16 0 0 0 5.93 5.93l.95-.95a2 2 0 0 1 2.11-.45c1.47.33 2.13.53 2.81.7A2 2 0 0 1 21.5 16v.92z"/></svg>
        720 992 745
      </a>
    </div>

    <!-- MOBILE: kategorie rozwijane -->
    <div class="mobile-cats">
      <button class="mobile-cats-toggle" @click="mobileOpen = !mobileOpen">
        {{ translations.nav?.categories_label || "Kategorie" }} <span>{{ mobileOpen ? '▲' : '▼' }}</span>
      </button>
      <div class="mobile-cats-list" v-if="mobileOpen">
        <router-link to="/category" class="mobile-cat-item" @click="mobileOpen=false">{{ translations.nav?.all || "Wszystkie" }}</router-link>
        <router-link
          v-for="c in categories" :key="c.id"
          :to="`/category/${c.slug}`"
          class="mobile-cat-item"
          @click="mobileOpen=false"
        >{{ c.name }}</router-link>
      </div>
    </div>
  </header>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount } from 'vue'
import eventBus from '@/eventBus'
import { currentLang, setLang, translations } from '@/locales/lang.js'
import { currentCurrency, setCurrency } from '@/composables/currency.js'

const cartCount = ref(0)
const categories = ref([])
const mobileOpen = ref(false)

const loadCategories = async () => {
  try {
    const r = await fetch('/api/v1/categories/', { headers: { 'Accept-Language': currentLang.value } })
    const d = await r.json()
    categories.value = (Array.isArray(d) ? d : d.results || []).map(c => ({...c, _open: false}))
  } catch(e) {}
}

const detectLocationSettings = async () => {
  try {
    const ctrl = new AbortController()
    setTimeout(() => ctrl.abort(), 2000)
    const r = await fetch('https://ipapi.co/json/', { signal: ctrl.signal })
    const data = await r.json()
    const country = data?.country_code
    if (!country) return
    const langMap = {DE:'de',AT:'de',PL:'pl',CZ:'cs',SK:'sk',SI:'sl',HR:'hr',HU:'hu',RO:'ro',BG:'bg',IT:'it',FR:'fr',ES:'es',NL:'nl',LT:'lt',EE:'et',DK:'da',SE:'sv',GB:'en',US:'en'}
    const curMap  = {PL:'PLN',CZ:'CZK',HU:'HUF',BG:'BGN',RO:'RON',DK:'DKK',SE:'SEK'}
    const EUR_COUNTRIES = ['DE','AT','FR','ES','IT','NL','BE','LU','IE','PT','FI','GR','LT','LV','EE','SK','SI','HR','CY','MT']
    const lang = langMap[country] || 'en'
    const cur  = curMap[country] || (EUR_COUNTRIES.includes(country) ? 'EUR' : 'EUR')
    setLang(lang); currentLang.value = lang; localStorage.setItem('selectedLang', lang)
    setCurrency(cur); currentCurrency.value = cur; localStorage.setItem('selectedCurrency', cur)
  } catch(e) {}
}

const changeLanguage = () => { setLang(currentLang.value); localStorage.setItem('selectedLang', currentLang.value); loadCategories() }
const changeCurrency = () => { setCurrency(currentCurrency.value); localStorage.setItem('selectedCurrency', currentCurrency.value) }
const updateCartCount = () => {
  const cart = JSON.parse(localStorage.getItem('cart') || '[]')
  cartCount.value = cart.reduce((s, i) => s + (i.quantity || 0), 0)
}

onMounted(() => {
  const savedLang = localStorage.getItem('selectedLang')
  const savedCurrency = localStorage.getItem('selectedCurrency')
  if (savedLang) { setLang(savedLang); currentLang.value = savedLang }
  if (savedCurrency) { setCurrency(savedCurrency); currentCurrency.value = savedCurrency }
  if (!savedLang || !savedCurrency) detectLocationSettings()
  updateCartCount()
  loadCategories()
  eventBus.on('cartUpdated', updateCartCount)
  window.addEventListener('storage', updateCartCount)
  window.addEventListener('languageChanged', loadCategories)
})
onBeforeUnmount(() => {
  eventBus.off('cartUpdated', updateCartCount)
  window.removeEventListener('storage', updateCartCount)
  window.removeEventListener('languageChanged', loadCategories)
})
</script>

<style scoped>
.site-header {
  background: #fff;
  border-bottom: 1px solid #f0f0f0;
  position: sticky; top: 0; z-index: 100;
  box-shadow: 0 2px 12px rgba(0,0,0,.04);
}

/* TOP */
.header-top {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 24px; height: 58px;
}
.header-phone-center {
  display: flex; align-items: center; justify-content: center; gap: 6px;
  color: #444; text-decoration: none;
  font-size: .85rem; font-weight: 600;
  white-space: nowrap;
}
.header-phone-center:hover { color: #111; }
@media(max-width: 768px) { .header-phone-center { display: none; } }
.site-logo {
  font-size: 1.4rem; font-weight: 900; color: #111;
  text-decoration: none; letter-spacing: -.03em;
  padding: 3px 0;
  white-space: nowrap;
}
.header-controls { display:flex; align-items:center; gap:10px; justify-content: flex-end; }
.lang-currency { display:flex; gap:6px; }
.header-select {
  border:1px solid #e5e7eb; border-radius:9999px;
  padding:5px 10px; font-size:.8rem; font-weight:600;
  background:#fff; cursor:pointer; outline:none;
  appearance:none; -webkit-appearance:none;
}
.cart-btn {
  position:relative; display:flex; align-items:center;
  background:#111; color:#fff; padding:8px; border-radius:50%;
  text-decoration:none;
}
.cart-count {
  position:absolute; top:-4px; right:-4px;
  background:#e63946; color:#fff; font-size:.65rem; font-weight:800;
  min-width:18px; height:18px; border-radius:9999px;
  display:flex; align-items:center; justify-content:center; padding:0 3px;
}

/* NAV BAR (desktop) */
.nav-label {
  font-size: .82rem; font-weight: 800; color: #111;
  white-space: nowrap; text-transform: uppercase; letter-spacing: .05em;
}
@media(max-width:768px) { .nav-label { display: none; } }
.header-nav-bar {
  display: flex; align-items: center;
  justify-content: center;
  padding: 0 24px;
  border-top: 1px solid #f5f5f5;
}
.header-nav { display:flex; align-items:center; overflow-x:auto; scrollbar-width:none; }
.header-nav::-webkit-scrollbar { display:none; }
.nav-item { position:relative; }
.nav-item a, .nav-all {
  display:inline-block; padding:10px 14px;
  font-size:.84rem; font-weight:700; color:#111;
  text-decoration:none; white-space:nowrap;
  border-bottom:2px solid transparent;
  transition:color .15s, border-color .15s;
}
.nav-item a:hover, .nav-all:hover { color:#111; border-bottom-color:#111; }
.nav-item a.router-link-active, .nav-all.router-link-active { color:#111; border-bottom-color:#111; }
.nav-all { color:#b07d4a; }
.nav-all:hover { border-bottom-color:#b07d4a; }
.nav-cat-link { display:inline-block; padding:10px 14px; font-size:.84rem; font-weight:700; color:#111; text-decoration:none; white-space:nowrap; border-bottom:2px solid transparent; transition:color .15s,border-color .15s; }
.nav-cat-link:hover { color:#111; border-bottom-color:#111; }

.nav-phone {
  display:flex; align-items:center; gap:6px;
  color:#444; text-decoration:none;
  font-size:.84rem; font-weight:700; color:#111; white-space:nowrap;
  padding:10px 0;
}
.nav-phone:hover { color:#111; }

/* MOBILE phone bar */
.mobile-phone-bar {
  display: none;
  text-align: center;
  padding: 6px;
  border-top: 1px solid #f5f5f5;
  font-size: .84rem; font-weight: 600;
}
.mobile-phone-bar a {
  display:inline-flex; align-items:center; gap:6px;
  color:#444; text-decoration:none;
}

/* MOBILE cats dropdown */
.mobile-cats { display: none; border-top: 1px solid #f5f5f5; }
.mobile-cats-toggle {
  width:100%; padding:10px 16px;
  background:none; border:none; cursor:pointer;
  font-size:.85rem; font-weight:700; text-align:left;
  display:flex; justify-content:space-between; align-items:center;
}
.mobile-cats-list { display:flex; flex-direction:column; }
.mobile-cat-item {
  padding:10px 20px; font-size:.85rem; font-weight:600;
  color:#444; text-decoration:none; border-top:1px solid #f5f5f5;
}
.mobile-cat-item:hover { background:#f9f9f9; color:#111; }

@media(max-width:768px) {
  .nav-label {
  font-size: .82rem; font-weight: 800; color: #111;
  white-space: nowrap; text-transform: uppercase; letter-spacing: .05em;
}
@media(max-width:768px) { .nav-label { display: none; } }
.header-nav-bar { display:none; }
  .mobile-phone-bar { display:block; }
  .mobile-cats { display:block; }
  .header-top { padding:0 12px; }
}
</style>
